import { useOutletContext } from "react-router-dom";
import ProductCard from "@/components/features/products/ProductCard";
import ProductCardSkeleton from "@/components/features/products/ProductCardSkeleton";
import type { Product } from "@/types/products";

const ProductList = () => {
  const { products, isLoadingProducts, hasMoreProducts, fetchMoreProducts } = useOutletContext<{
    products: Product[];
    isLoadingProducts: boolean;
    hasMoreProducts: boolean;
    fetchMoreProducts: () => void;
  }>();

  if (products.length === 0 && !hasMoreProducts && !isLoadingProducts) {
    return (
      <p className="brand-text-sm flex min-h-80 items-center justify-center text-neutral">
        無符合的商品
      </p>
    );
  }

  return (
    <>
      <div className="grid grid-cols-2 gap-x-4 gap-y-8 lg:grid-cols-3 xl:grid-cols-4">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            // cartLoadingState={cartLoadingState}
            // onAddToCartClick={handleAddToCartAction}
            // modalState={openAttrsModalState}
            // onAddToCart={addProductToCart} // to
            // onAttrSelect={handleAttrOptionSelect}
            // isAttrSelected={isAttrOptionSelected}
            // isAllAttrsSelected={isAllAttrsSelected}
            // onModalClose={handleAttrsModalClose}
          />
        ))}
      </div>
      {/* Load More */}
      <div className="mt-8">
        {hasMoreProducts && !isLoadingProducts && (
          <div className="flex justify-center">
            <button
              onClick={fetchMoreProducts}
              disabled={isLoadingProducts}
              type="button"
              className="brand-btn-base btn btn-outline flex items-center px-4 py-2"
            >
              顯示更多商品
            </button>
          </div>
        )}
        {isLoadingProducts && (
          <div className="grid grid-cols-2 gap-x-4 gap-y-8 lg:grid-cols-3 xl:grid-cols-4">
            {Array.from({ length: 4 }).map((_, index) => (
              <ProductCardSkeleton key={index} />
            ))}
          </div>
        )}
        {!hasMoreProducts && products.length > 0 && (
          <p className="brand-text-sm text-center text-neutral">已顯示所有商品</p>
        )}
      </div>
    </>
  );
};

export default ProductList;
